<template>
    <div>
      <v-card>
        <v-card-text>
        <h1>InnoDOT VOT</h1>
          <h2 class="mt-5">Export Data For InnoDOT</h2>
          <v-row>
            <!-- <v-col lg="3">
              <label>Township</label>
              <v-select
                v-model="township_id"
                outlined
                dense
                item-text="name"
               a item-value="id"
                :items="townships"
              ></v-select>
              <label>Township Group</label>
            <v-select
              v-model="township_group_id"
              outlined
              dense
              item-text="name"
              item-value="id"
              :items="townshipGroups"
            ></v-select>
            </v-col> -->
            <v-col lg="3">
              <label>From Date</label>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dots_startdate_from"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dots_startdate_from"
                  no-title
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col lg="3">
              <label>To Date</label>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dots_startdate_to"
                    outlined
                    dense
                    readonly
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dots_startdate_to"
                  no-title
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col lg="3">
              <label>DOT App Use</label>
              <v-select
                v-model="dots_app_status"
                outlined
                dense
                item-text="text"
              item-value="value"
                :items="[
                { value: 1, text: `No` },
                { value: 2, text: `Yes` },
                { value: 3, text: `All` },
              ]"
              ></v-select>
            </v-col>
           <v-col lg="3"><br>
            <v-btn class="form-btn" @click="exportData">
                <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
            </v-btn>
           </v-col>
          </v-row>
          <hr>
          <div class="my-5">
            <h2>Import Data From InnoDOT</h2>

          <v-row>
            <v-col lg="3">
              <label>Upload CSV or XLSX File</label>
              <div class="my-2">
                <input type="file" @change="handleFileUpload" accept=".csv, .xlsx" />
                </div>
            </v-col>
            <v-col lg="6">
              <br>
              <v-btn v-if="excelData.length" class="form-btn" @click="uploadToBackend">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Import
            </v-btn>
            </v-col>
          </v-row>
          
          </div>
         
        </v-card-text>
        <v-card-actions>
         
          
        </v-card-actions>
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import * as XLSX from "xlsx";
  import moment from "moment";
  
  export default {
    components: {},
     
    data: () => ({
     // township_id: null,
      township_group_id:null,
      dots_startdate_from: null,
      dots_startdate_to:null,
      dots_app_status: 1,

      dataList: [],
      headers: [], // Headers of the CSV/XLSX
      excelData: [], // Parsed data rows
    }),
    computed: {
      ...mapState("TownshipGroup", ["townshipGroups"]),
    },
    methods: {

    exportData() {
        let data = {
        //  township_id: this.township_id ? this.township_id :null,
          township_group_id:this.township_group_id ? this.township_group_id :null,
          dots_app_status: this.dots_app_status,
          
        };
        if (this.dots_startdate_from && this.dots_startdate_to) {
          data.dots_startdate_from=moment(this.dots_startdate_from).format("YYYY-MM-DD");
          data.dots_startdate_to=moment(this.dots_startdate_to).format("YYYY-MM-DD");
          
          if( data.dots_startdate_from> data.dots_startdate_to)
          {
             data.dots_startdate_from=null;
             data.dots_startdate_to=null;
             alert('Cannot be greater than From Date');
             return false;
          }
        }else
        {
            data.dots_startdate_from=null;
            data.dots_startdate_to=null;
             alert('Please select From and To date');
             return false;
        }
        this.$store.dispatch("Presumptive/dotsgetExport", data);
      },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Parse the first sheet

        const sheetName = workbook.SheetNames[0];

        const sheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON array
        const rows = XLSX.utils.sheet_to_json(sheet, { 
            header: 1, 
            raw: true 
        });

        this.headers = rows[0]; // First row is the header
        this.excelData = rows.slice(1); // Remaining rows are data
      };

      reader.readAsArrayBuffer(file);
      const fileType = file.type;
        if (fileType !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            fileType !== "text/csv") {
        alert("Only CSV or Excel files are allowed!");
        return;
        }

    },
    uploadToBackend() {
      
      const formattedData = this.excelData.map((row) => {
       
        return this.headers.reduce((acc, header, index) => {
          acc[header] = row[index] || null;
          return acc;
        }, {});
      });

      this.$store.dispatch("DataImport/importInnoDotData",{ data: formattedData })
            .then(() => {
                alert("Import file?");
              
            }).catch((error) => {
                console.error("Error uploading data:", error);
            });

    },

    },
    created() {
      this.$store.dispatch("TownshipGroup/getTownshipGroups");
    },
  };
  </script>
  
  <style scoped></style>
  